<div class="container-fluid">

<h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-book mr-2"></i> Trình xem thư viện 3D
  </h1>
  
  <p class="lead mb-4">
    Trình xem thư viện 3D cho phép bạn khám phá và tương tác với một thư viện ảo. Xem kệ sách và sách trong môi trường 3D, quản lý vị trí của chúng và nhận thông tin chi tiết về từng cuốn sách như tiêu đề và hình ảnh bìa. Nâng cao trải nghiệm người dùng với kết xuất cảnh động và điều khiển liền mạch.
  </p>

</div>

<form>
  <label for="department">Chọn Khoa:</label>
  <select id="department" (change)="onSelectChange($event)">
    <option></option>
    <option *ngFor="let department of departments" [value]="department.departmentCode">
      {{ department.departmentName }}
    </option>
  </select>
</form>

<div #rendererContainer></div>